import React from 'react';
import PropTypes from 'prop-types';

import funderaByNw from '../../assets/images/logos/fundera-by-nw.svg';
import Image from '../Image';

import * as styles from './Logo.module.less';

const fundera = {
  src: funderaByNw,
};

const Logo = props => {
  const { logoImage, logoURL } = props;

  return (
    <a href={logoURL} className={styles.wrapper}>
      <Image
        alt="logo"
        src={fundera.src}
        loading="lazy"
        height="36"
        width="144"
      />
    </a>
  );
};

Logo.propTypes = {
  logoImage: PropTypes.number,
  logoURL: PropTypes.string,
};

Logo.defaultProps = {
  logoImage: 0,
  logoURL: '/',
};

export default Logo;
